import React from "react";
import Card from "components/card"; 
import { Sparkles, Star, Trophy } from "lucide-react";
import Button from "components/button";

const Notification = ({
    onClose
}) => {
    return (
        <Card className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
            z-50 grid w-full max-w-md sm:max-w-lg gap-4
            p-0 rounded-lg border-none bg-transparent shadow-none overflow-visible
            duration-200
            animate-in fade-in-0 zoom-in-95"
        >
            <div className="relative">
                <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-emerald-400 opacity-100 transform-none">
                    <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 via-purple-500 to-blue-500 opacity-90"></div>
                    <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/10 rounded-full"></div>
                    <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-white/10 rounded-full"></div>
                    <div className="relative z-10 p-8 text-center">
                        <div className="inline-block mb-6 opacity-100 transform-none">
                            <div className="relative">
                                <div className="p-6 rounded-full bg-gradient-to-br from-yellow-300 to-amber-400 shadow-2xl">
                                    <Trophy className="w-16 h-16 text-white" />
                                </div>
                                <div className="absolute -top-2 -right-2">
                                    <Sparkles className="w-6 h-6 text-yellow-300" />
                                </div>
                                <div className="absolute -bottom-2 -left-2">
                                    <Star className="w-6 h-6 text-yellow-300" />
                                </div>
                            </div>
                        </div>
                        <h2 className="text-4xl mb-2 text-white font-medium opacity-100 transform-none">
                            Congratulations!
                        </h2>
                        <p className="text-lg text-white/90 mb-6 font-medium opacity-100 transform-none">
                            Dillon Esteban
                        </p>
                        <div className="mb-6 transform-none">
                            <div className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-white/20 backdrop-blur-md border-2 border-white/30">
                                <span className="text-5xl text-white font-extrabold">
                                    + 100
                                </span>
                                <div className="text-left">
                                    <p className="text-sm text-white/80">Hyvid</p>
                                    <p className="text-lg text-white font-semibold">Points</p>
                                </div>
                            </div>
                        </div>
                        <div className="mb-6 opacity-100 transform-none">
                            <span className="inline-flex items-center justify-center rounded-lg border font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden px-4 py-2 text-sm bg-white/20 backdrop-blur-md text-white border-white/30">
                                Exceptional Performance
                            </span>
                        </div>
                        <p className="text-white/80 text-sm mb-6 max-w-sm mx-auto opacity-100 transform-none">
                            Your hard work and dedication have been recognized! Keep up the amazing work.
                        </p>
                        <div className="opacity-100 transform-none">
                            <Button
                                onClick={() => onClose?.()}
                                className="access-button btn-awesome"
                            >
                                Awesome! Thank You
                            </Button>
                        </div>
                        <div className="absolute inset-0 pointer-events-none">
                            <div className="absolute" style={{ left: "15%", top: "20%", transform: "translateY(-8.7px) scale(1.17442)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "30%", top: "40%", transform: "translateY(-1.94px) scale(1.03886)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "45%", top: "60%", transform: "translateY(-7.49px) scale(1.14985)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "60%", top: "20%", transform: "translateY(-10px) scale(1.2)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "75%", top: "40%", transform: "translateY(-4.47px) scale(1.0894)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "90%", top: "60%", transform: "translateY(-0.41px) scale(1.00812)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                            <div className="absolute" style={{ left: "50%", top: "30%", transform: "translateY(-5px) scale(1.1)" }}>
                                <Sparkles className="w-4 h-4 text-white/50"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default Notification;